import React, { useEffect, useState } from "react";
import {
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  ResponsiveContainer,
} from "recharts";
import axios from "../../../axios/axios";
import { Button, Form } from "react-bootstrap";
import moment from "moment";
import { adminConfig } from "../../../utils/adminConfig";

const CertificateReportsGraph = () => {
  const [chartData, setChartData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");

  useEffect(() => {
    const fetchGraphData = async () => {
      try {
        const res = await axios.get(
          `/get-all-send-and-redeem-certificates-report?startDate=${startDate}&endDate=${endDate}`,
          adminConfig()
        );
        const { data } = res.data;
        setChartData(data);
      } catch (err) {
        console.error("Failed to load chart data", err);
      }
    };

    fetchGraphData();
  }, [startDate, endDate]);

  return (
    <div className="mb-5">
      <div className="filter_section">
        <div className="input-group filter_fields">
          <Form.Group controlId="formBasicEmail" className="dt_range">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={selectedStartDate}
              max={selectedEndDate || moment().format("YYYY-MM-DD")}
              onChange={(e) => setSelectedStartDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="formBasicEmail" className="dt_range">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={selectedEndDate}
              min={selectedStartDate}
              max={moment().format("YYYY-MM-DD")}
              onChange={(e) => setSelectedEndDate(e.target.value)}
            />
          </Form.Group>

          <Button
            className="search_button"
            variant="primary"
            onClick={() => {
              setStartDate(selectedStartDate);
              setEndDate(selectedEndDate);
            }}
          >
            Search
          </Button>

          <Button
            className="search_button"
            variant="secondary"
            onClick={() => {
              setSelectedStartDate("");
              setSelectedEndDate("");
              setStartDate("");
              setEndDate("");
            }}
          >
            Clear Filter
          </Button>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="redeemCount" name="Redeem Count" fill="#8884d8" />
          <Bar dataKey="sendCount" name="Send Count" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CertificateReportsGraph;
